import { render, staticRenderFns } from "./ReviewPercentageBar.vue?vue&type=template&id=fd241058&scoped=true&"
import script from "./ReviewPercentageBar.vue?vue&type=script&lang=js&"
export * from "./ReviewPercentageBar.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPercentageBar.vue?vue&type=style&index=0&id=fd241058&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd241058",
  null
  
)

export default component.exports